<template>
    <div class="col-md-6" v-if="banner.target" v-bind:id="'banner_'+banner.id">
        <div class="bannerWrap">
            <div class="innerBox">
                <a v-bind:href="banner.url" target="_blank">
                    <img v-bind:src="banner.image" v-bind:alt="banner.name">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BannerView",
        props:{
            banner:{
                type:Object,
                default: () => {}
            }
        }
    }
</script>
<style scoped>
    .bannerWrap{
        margin-top:30px;
    }
    .bannerWrap a{
        display: block;

    }
    .bannerWrap img{
        width:100%;
        /*max-width: 753px;*/
        /*max-height: 157px;*/
    }
</style>
